import React from "react";
import { Outlet } from "react-router-dom";
import StudioLayout from "../Layout/StudioLayout";

/**
 * Layout shell for Studio. Auth is enforced by AuthenticatedRoute; RBAC by AuthorizedRoute.
 */
const StudioRoute = () => (
	<StudioLayout>
		<Outlet />
	</StudioLayout>
);

export default StudioRoute;
